import { lazy, Suspense } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';

// Lazy-load every section below the fold
const About = lazy(() => import('./components/About'));
const Services = lazy(() => import('./components/Services'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const Statistics = lazy(() => import('./components/Statistics'));
const KeywordSeoSection = lazy(() => import('./components/KeywordSeoSection'));
const FaqSection = lazy(() => import('./components/FaqSection'));
const FooterCTA = lazy(() => import('./components/FooterCTA'));

const SectionSkeleton = ({ height = 'h-64' }: { height?: string }) => (
  <div className={`${height} bg-[#0d0d0d] w-full`} />
);

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0d0d0d]">
      <Navigation />
      <main>
        {/* Hero is above-fold — load eagerly */}
        <Hero />

        {/* All below-fold sections lazy-loaded */}
        <Suspense fallback={<SectionSkeleton height="h-[240vh]" />}>
          <About />
        </Suspense>

        <Suspense fallback={<SectionSkeleton height="h-[80vh]" />}>
          <Services />
        </Suspense>

        <Suspense fallback={<SectionSkeleton height="h-96" />}>
          <Testimonials />
        </Suspense>

        <Suspense fallback={<SectionSkeleton height="h-48" />}>
          <Statistics />
        </Suspense>

        <Suspense fallback={<SectionSkeleton height="h-96" />}>
          <KeywordSeoSection />
        </Suspense>

        <Suspense fallback={<SectionSkeleton height="h-96" />}>
          <FaqSection />
        </Suspense>
      </main>

      <Suspense fallback={<SectionSkeleton height="h-64" />}>
        <FooterCTA />
      </Suspense>
    </div>
  );
}
